module.exports = __webpack_public_path__ + "img/noStart.60775abb.png";